export interface ProductCushionSpec {
  id: string;
  productId: string;
  length: number;
  width: number;
  height: number;
  trimDescriptionKey: string;
  trimDescriptionDescription: string;
  trimDescriptionId: string;
  labelPlacementKey: string;
  labelPlacementDescription: string;
  labelPlacementId: string;
  brandLabelKey: string;
  brandLabelDescription: string;
  brandLabelId: string;
  careLabelKey: string;
  careLabelDescription: string;
  careLabelId: string;
  newCareLabelKey: string;
  newCareLabelDescription: string;
  newCareLabelId: string;
  origin: string;
  originId: string;
}
